import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useDeprecatedPropsWarning } from '@nerdwallet/deprecate';
import { useDeprecatedClassNameStylePropsWarning } from '../../internal/deprecated-classname-style-props';
import { LegacyLink } from './LegacyLink';
import { SimpleLink } from './SimpleLink';
import isExternalLink from './isExternalLink';
var deprecatedProps = ['chronicle', 'color', 'decorated', 'italic', 'unstyled', 'uppercase'];

/**
 * To keep styles simple while also retaining backwards compatibility, this
 * component has been bifurcated into two internal components: `<SimpleLink>`
 * and `<LegacyLink>`. If no deprecated props are used, `<SimpleLink>` will be
 * rendered. Otherwise, `<LegacyLink>` will be used instead.
 *
 * During the next major version bump, `<LegacyLink>` should be removed and
 * `<SimpleLink>` should become the implementation of `<Link>`.
 */
export var Link = /*#__PURE__*/React.forwardRef(function (props, ref) {
  useDeprecatedPropsWarning({
    component: 'Link',
    deprecatedProps: [{
      deprecated: 'chronicle',
      migration: 'Designers should not be using Chronicle in links. Slack #design-system with your use case and to get help!',
      version: '1.7.0'
    }, {
      deprecated: 'color',
      migration: 'All links should appear as default blue. Slack #design-system with your use case and to get help!',
      version: '1.7.0'
    }, {
      deprecated: 'decorated',
      migration: 'All links should appear as default blue at this time, so underline is not needed. Slack #design-system with your use case and to get help!',
      version: '1.7.0'
    }, {
      deprecated: 'italic',
      migration: 'Designers should not be using italic in links. Slack #design-system with your use case and to get help!',
      version: '1.7.0'
    }, {
      deprecated: 'uppercase',
      migration: 'All links should appear Body, Body Small or Legal at this time. Slack #design-system with your use case and to get help!',
      version: '1.7.0'
    }, {
      deprecated: 'unstyled',
      migration: 'All links should appear as default blue. Slack #design-system with your use case and to get help!',
      version: '1.7.0'
    }],
    props: props
  });
  useDeprecatedClassNameStylePropsWarning('Link', {
    className: props.className,
    style: props.style
  });
  var needsLegacyLink = deprecatedProps.some(function (deprecatedProp) {
    return !!props[deprecatedProp];
  });
  var rel;

  if (props.href && props.target === '_blank' && isExternalLink(props.href)) {
    rel = 'noopener';
  }

  if (needsLegacyLink) {
    return /*#__PURE__*/React.createElement(LegacyLink, _extends({
      rel: rel
    }, props, {
      ref: ref
    }));
  }

  return /*#__PURE__*/React.createElement(SimpleLink, _extends({
    rel: rel
  }, props, {
    ref: ref
  }));
});
Link.displayName = 'Link';